import React, { useEffect, useState } from "react";
import { ServiceSection } from "../../AdminStyle.styled";
import { Row, Col, Button, Table, Modal, Tag } from "antd";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  DeleteSales,
  GetAllSales,
  CreateSales,
  UpdateSales,
  GetAllProducts,
  GetOneConfiguredServices,
} from "../../../../../redux/actions/adminActions";
import { Delete, Edit, Add } from "@mui/icons-material";
import CreateSalesModal from "./CreateSalesModal";
import { phoneNumberFormat, priceFormat } from "../../../../../utils";

const SalesModal = (props) => {
  const {
    // one_service,
    GetAllSales,
    DeleteSales,
    CreateSales,
    UpdateSales,
    allSales,
    allProducts,
    GetAllProducts,
    my_roles,
    user_details,
  } = props;

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [formMode, setFormMode] = useState("CREATE_MODE");
  const [salesRecord, setSalesRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: allSales?.length,
  });

  const editRecord = async (record) => {
    setSalesRecord(record);
    setVisible(true);
    setFormMode("UPDATE_MODE");
  };

  const deleteRecord = (record) => {
    Modal.confirm({
      title: "Do you want to delete this record?",
      content: "Click yes to proceed",
      okText: "Delete",
      loading: deleteLoading,
      okType: "danger",
      async onOk() {
        setDeleteLoading(true);
        const res = await DeleteSales(record.id);
        if (res.success) {
          setDeleteLoading(false);
          toast.success(res.message, {
            pauseOnHover: false,
          });
        } else {
          toast.info(res.message, {
            pauseOnHover: true,
          });
        }
      },
      onCancel() {
        setDeleteLoading(false);
        return false;
      },
    });
  };
  const CreateService = () => {
    setVisible(true);
    setFormMode("CREATE_MODE");
    setSalesRecord(null);
  };

  const closeModal = () => {
    setVisible(false);
    setFormMode("CREATE_MODE");
    setSalesRecord(null);
  };

  const privileges = my_roles[0]?.role?.privileges;

  const recordColumn = [
    {
      title: "Name",
      dataIndex: "buyer_name",
    },
    {
      title: "Phone Number",
      dataIndex: "buyer_phone",
      // align: "center",
      // render: (_text, record) => <>{phoneNumberFormat(record?.buyer_phone)}</>,
    },
    {
      title: "Product",
      dataIndex: "product_name",
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      align: "center",
      render: (_text, record) => <>{priceFormat(record?.unit_price)}</>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
    },
    {
      title: "Total Price",
      dataIndex: "amount",
      align: "center",
      render: (_text, record) => <>{priceFormat(record?.amount)}</>,
    },
    // {
    //   title:
    //     !user_details?.is_staff &&
    //     (privileges?.includes("sales.edit_sale") ||
    //       privileges?.includes("sales.delete_sale"))
    //       ? "action"
    //       : null,
    //   dataIndex: "action",
    //   align: "center",
    //   render: (_text, record) => (
    //     <>
    //       {!user_details?.is_staff &&
    //       (privileges?.includes("sales.edit_sale") ||
    //         privileges?.includes("sales.delete_sale")) ? (
    //         <div className="actiontable">
    //           {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    //           {privileges?.includes("sales.edit_sale") && (
    //             <button className="eid" onClick={() => editRecord(record)}>
    //               <Edit />
    //             </button>
    //           )}
    //           {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    //           {privileges?.includes("sales.delete_sale") && (
    //             <button className="del" onClick={() => deleteRecord(record)}>
    //               <Delete />
    //             </button>
    //           )}
    //         </div>
    //       ) : null}
    //     </>
    //   ),
    // },
  ];

  useEffect(() => {
    const getSalesRecords = async () => {
      setLoading(true);
      const res = await GetAllSales();
      setLoading(false);
      if (!res.success) {
        setLoading(false);
        toast.error(`Error`);
      }
    };
    getSalesRecords();
  }, [GetAllSales]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  return (
    <ServiceSection>
      {(user_details?.is_staff || privileges?.includes("sales.add_sale")) && (
        <Row>
          <Col xs={24}>
            <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Button
                onClick={CreateService}
                icon={<Add style={{ marginRight: "8px" }} />}
                type="primary"
              >
                {" "}
                Add Purchase
              </Button>
            </div>
          </Col>
        </Row>
      )}

      <Table
        rowKey="id"
        style={{ overflowX: "auto" }}
        loading={loading}
        columns={recordColumn}
        dataSource={allSales?.slice(
          (pagination.current - 1) * pagination.pageSize,
          pagination.current * pagination.pageSize
        )}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: false,
          showQuickJumper: false,
        }}
        onChange={handleTableChange}
      />

      <CreateSalesModal
        visible={visible}
        closeModal={closeModal}
        formMode={formMode}
        one_sale={salesRecord}
        CreateSales={CreateSales}
        UpdateSales={UpdateSales}
        allProducts={allProducts}
        GetAllProducts={GetAllProducts}
      />
    </ServiceSection>
  );
};

const mapStateToProps = (state) => {
  return {
    allSales: state.adminReducer.allSales,
    one_sale_record: state.adminReducer.one_sale_record,
    allProducts: state.adminReducer.allProducts,
    my_roles: state.userManagementReducer.my_roles,
    user_details: state.authReducer.user_details,
  };
};

export default connect(mapStateToProps, {
  GetAllSales,
  CreateSales,
  DeleteSales,
  UpdateSales,
  GetAllProducts,
  GetOneConfiguredServices,
})(SalesModal);
